<div class="app-chart-pagination-toolbar">
  <button mat-button (click)="previous()" [disabled]="previousDisabled" aria-label="früher">
    <mat-icon>arrow_left</mat-icon>
  </button>
  <div class="spacer"><div class="text">{{text}}</div></div>
  <button mat-button [disabled]="nextDisabled" (click)="next()" aria-label="später">
    <mat-icon>arrow_right</mat-icon>
  </button>
</div>
